import { GoBack } from "@/components/shared/layout"

const AboutPage = () => {
  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header */}
      <div className="sticky top-0 z-50">
        <GoBack title="Về ZZP" className="bg-white" />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto p-4 space-y-4">
        <div className="space-y-3">
          <p className="text-sm text-gray-700 leading-relaxed">
            Ứng dụng ZZP là ứng dụng cung cấp nền tảng kết nối giữa Nhà sáng tạo nội dung/ Người có
            sức ảnh hưởng (KOL/KOC) và các Nhà bán hàng (Seller)/Nhãn hàng (Brand).
          </p>
          <p className="text-sm text-gray-700 leading-relaxed">
            Ứng dụng ZZP được phát triển bởi{" "}
            <strong className="text-primary">Công ty Cổ Phần ALPHA SPACEZ</strong>, là đơn vị được
            cấp Giấy chứng nhận đăng ký doanh nghiệp số 0319219773 do Sở Tài chính Thành phố Hồ Chí
            Minh cấp lần đầu ngày 16/10/2025.
          </p>
        </div>

        <div className="space-y-2">
          <p className="text-sm font-semibold text-gray-800">Thông tin liên hệ:</p>
          <div className="bg-gray-50 rounded-lg p-4 border space-y-2">
            <p className="text-sm font-bold text-primary">CÔNG TY CỔ PHẦN ALPHA SPACEZ</p>
            <p className="text-sm text-gray-600">
              <span className="font-medium">Mã số thuế:</span> 0319219773
            </p>
            <p className="text-sm text-gray-600">
              <span className="font-medium">Địa chỉ:</span> A3.7 & A3.9, Tầng 3, Block A, Tòa Nhà
              Jamona Height, Số 210 Bùi Văn Ba, Phường Tân Thuận, Thành phố Hồ Chí Minh, Việt Nam
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutPage
